import React from 'react';
import { connect } from 'react-redux';
import { IconButton } from '@material-ui/core';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { runtime } from '../../../common';

const Footer = ({containerFooter}) => {
    return (
      runtime.pc?
      <footer className="app-footer">
        <span className="d-inline-block">入微网 &copy; 2020</span>
      </footer>:
      <div className={`app-footer-wrapper`}>
     
      </div>
    );
  }
;

const mapStateToProps = ({settings}) => {
  const {containerFooter} = settings;
  return {containerFooter}
};

export default connect(mapStateToProps, {})(Footer);